var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-slider"},[_c('carousel',{attrs:{"perPage":1,"speed":150,"navigationEnabled":true,"paginationEnabled":false}},_vm._l((_vm.slides),function(i){return _c('slide',{key:i},[_vm._t(i)],2)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }